exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".counts[data-v-68d3995c]{font-size:1.2em}.counts .badge[data-v-68d3995c]{font-size:.8em!important;height:24px}.subtitle[data-v-68d3995c]{font-weight:700;font-size:1.2em}.panel .table tr td[data-v-68d3995c]:first-child,.panel .table tr th[data-v-68d3995c]:first-child{padding-left:1.5em}.panel .table tr td[data-v-68d3995c]:last-child,.panel .table tr th[data-v-68d3995c]:last-child{padding-right:1.5em}.panel-heading[data-v-68d3995c]{font-weight:700}", ""]);

// exports
